import { useState, type Dispatch, type SetStateAction } from 'react';
import type { Site, PageLayout, Component } from '../../schemas/validation';

export interface LayoutEditorState {
  site: Site | null;
  setSite: (site: Site | null) => void;
  layout: PageLayout | null;
  setLayout: (layout: PageLayout | null) => void;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  showComponentLibraryModal: boolean;
  setShowComponentLibraryModal: (show: boolean) => void;
  isSaving: boolean;
  setIsSaving: (saving: boolean) => void;
  components: Component[];
  setComponents: Dispatch<SetStateAction<Component[]>>;
  themeColors: any;
  setThemeColors: (colors: any) => void;
  isLoadingTheme: boolean;
  setIsLoadingTheme: (loading: boolean) => void;
  themeError: string | null;
  setThemeError: (error: string | null) => void;
  currentThemeName: string | null;
  setCurrentThemeName: (name: string | null) => void;
  hasUnsavedChanges: boolean;
  setHasUnsavedChanges: (has: boolean) => void;
  insertPosition: number | null;
  setInsertPosition: (position: number | null) => void;
  layoutName: string;
  setLayoutName: (name: string) => void;
  layoutDescription: string;
  setLayoutDescription: (desc: string) => void;
  isDefault: boolean;
  setIsDefault: (isDefault: boolean) => void;
  deleteModal: { isOpen: boolean; component: Component | null };
  setDeleteModal: (modal: { isOpen: boolean; component: Component | null }) => void;
}

export const useLayoutEditorState = (): LayoutEditorState => {
  const [site, setSite] = useState<Site | null>(null);
  const [layout, setLayout] = useState<PageLayout | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showComponentLibraryModal, setShowComponentLibraryModal] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [components, setComponents] = useState<Component[]>([]);
  const [themeColors, setThemeColors] = useState<any>(null);
  const [isLoadingTheme, setIsLoadingTheme] = useState(false);
  const [themeError, setThemeError] = useState<string | null>(null);
  const [currentThemeName, setCurrentThemeName] = useState<string | null>(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [insertPosition, setInsertPosition] = useState<number | null>(null);
  const [layoutName, setLayoutName] = useState('');
  const [layoutDescription, setLayoutDescription] = useState('');
  const [isDefault, setIsDefault] = useState(false);
  const [deleteModal, setDeleteModal] = useState<{
    isOpen: boolean;
    component: Component | null;
  }>({ isOpen: false, component: null });

  return {
    site,
    setSite,
    layout,
    setLayout,
    isLoading,
    setIsLoading,
    showComponentLibraryModal,
    setShowComponentLibraryModal,
    isSaving,
    setIsSaving,
    components,
    setComponents,
    themeColors,
    setThemeColors,
    isLoadingTheme,
    setIsLoadingTheme,
    themeError,
    setThemeError,
    currentThemeName,
    setCurrentThemeName,
    hasUnsavedChanges,
    setHasUnsavedChanges,
    insertPosition,
    setInsertPosition,
    layoutName,
    setLayoutName,
    layoutDescription,
    setLayoutDescription,
    isDefault,
    setIsDefault,
    deleteModal,
    setDeleteModal,
  };
};
